





















import { Component, Vue } from 'vue-property-decorator'
import TranslationModule from '@/utils/TranslationModule'
import { ApplyStep } from '@/utils/ApplyAttr'
import { namespace } from 'vuex-class'

const apply = namespace('apply')

@Component
export default class ApplyHeader extends Vue {
    @apply.Getter flow!: string

    get items() {
        const profile = this.createItem(ApplyStep.PROFILE, 'v2.header.steps.step1')
        const validationBack = this.createItem(ApplyStep.VALIDATION, 'v2.header.steps.step2.batch')
        const membership = this.createItem(ApplyStep.MEMBERSHIP, 'v2.header.steps.step2')
        const payment = this.createItem(ApplyStep.PAYMENT, 'v2.header.steps.step3')
        const validation = this.createItem(ApplyStep.VALIDATION, 'v2.header.steps.step4')

        return ['batch', 'batch-sponsorship'].includes(this.flow)
            ? [profile, validationBack, membership, payment]
            : [profile, membership, payment, validation]
    }

    createItem(id: ApplyStep, label: string) {
        return {
            id,
            label: this.$trans(label, TranslationModule.APPLY),
        }
    }
}
